import { SelectOption as CurrencySelectOptions } from 'types/types'
import { useFiatCurrenciesQuery } from './queries'

export const useCurrencyOptions = (): CurrencySelectOptions[] => {
  const { data: fiatCurrencies } = useFiatCurrenciesQuery()

  const currencyOptions =
    fiatCurrencies?.map(currency => ({
      label: `${currency?.name} (${currency?.code})`,
      value: currency?.code,
    })) || []

  return currencyOptions
}
